import React from 'react';
import {concatenate} from "services/string";

enum Alignment {LEFT, CENTER, RIGHT}

enum Transform {NORMAL, UPPERCASE, LOWERCASE, CAPITALIZE}

enum DisplaySize {ALL, X_SMALL, SMALL, MEDIUM, LARGE, X_LARGE}

type Props = {
    alignment: Alignment
    transform: Transform
    displaySize: DisplaySize
    colSpan?: number
    children?: React.ReactNode
}

const alignmentClasses: Record<Alignment, string> = {
    [Alignment.LEFT]: 'text-left',
    [Alignment.CENTER]: 'text-center',
    [Alignment.RIGHT]: 'text-right',
}

const transformClasses: Record<Transform, string> = {
    [Transform.NORMAL]: 'normal-case',
    [Transform.UPPERCASE]: 'uppercase',
    [Transform.LOWERCASE]: 'lowercase',
    [Transform.CAPITALIZE]: 'capitalize',
}

const displaySizeClasses: Record<DisplaySize, string> = {
    [DisplaySize.ALL]: '',
    [DisplaySize.X_SMALL]: 'hidden xs:table-cell',
    [DisplaySize.SMALL]: 'hidden sm:table-cell',
    [DisplaySize.MEDIUM]: 'hidden md:table-cell',
    [DisplaySize.LARGE]: 'hidden lg:table-cell',
    [DisplaySize.X_LARGE]: 'hidden xl:table-cell',
}

function TableData(props: Props) {
    const {colSpan, alignment, transform, displaySize, children} = props

    return (
        <td colSpan={colSpan || 1} className={concatenate(
                alignmentClasses[alignment],
                transformClasses[transform],
                displaySizeClasses[displaySize],
                'relative px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-600'
            )}>
            {children}
        </td>
    );
}

TableData.alignments = Alignment
TableData.transforms = Transform
TableData.displaySizes = DisplaySize

TableData.defaultProps = {
    alignment: Alignment.LEFT,
    transform: Transform.NORMAL,
    displaySize: DisplaySize.ALL
}

export default TableData;